import React from 'react';

const DesktopSideNav = () => {
  return <div className="mb-[32px]">Desktop Side Nav</div>;
};

export default DesktopSideNav;
